import { render, staticRenderFns } from "./dandelion-navigation-mobile.vue?vue&type=template&id=d5369f10&scoped=true&"
import script from "./dandelion-navigation-mobile.vue?vue&type=script&lang=js&"
export * from "./dandelion-navigation-mobile.vue?vue&type=script&lang=js&"
import style0 from "./dandelion-navigation-mobile.vue?vue&type=style&index=0&id=d5369f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5369f10",
  null
  
)

export default component.exports